/* checks, if provided first date is more the provided number of days in the future. If so, true is returned */

export default function showCallcenterHint(numberOfDays: number, firstStartDate: string): boolean {

  let returnValue = false;

  if(firstStartDate != null){

    const currentDate = new Date();
    const asDate = new Date(firstStartDate);
    const diffInDays = (asDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24);

    if(diffInDays > numberOfDays){
      returnValue = true;
    }
  }

  return returnValue;
}